import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'abbreviation',
})
export class AbbreviationPipe implements PipeTransform {
  transform(value: string): any {
    return !!value ? value[0] : null;
  }
}
